// English-label basemap. Esri World Street Map renders Latin/English labels worldwide
// (CARTO/OSM tiles show Arabic street names at high zoom in the UAE).
export const TILE_URL =
  "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
export const TILE_ATTR = "Tiles &copy; Esri";
